import React from "react";
import styles from "./ChangeDetectedItem.module.scss";
import { useSelector } from "react-redux";

const ChangeDetectedItem = ({ cancel, onSave }) => {
  const { isChangeBan } = useSelector(state => state.changeBan)
  
  return (
      <div className={styles.change_detected_item_wrapp}>
        <p className={styles.change_detected_text}>Changes Detected!</p>
        <div className={styles.change_detected_btn_wrapp}>
          <button onClick={cancel} className={styles.change_btn_cancel} type="button">
            Cancel
          </button>
          <button
            className={`${styles.change_btn_save}`}
            type="button"
            onClick={onSave} 
          >
            Save
          </button>
        </div>
      <div className={isChangeBan ? styles.change_detected_alert_wrapper : styles.isHidden}>
        <div className={styles.change_detected_alert}>
          <p className={styles.change_detected_alert_text}>
          Save your changes!
          </p>
        </div>
        </div>
      </div>
  );
};

export default ChangeDetectedItem;
